import * as Actions from "../actions/ActionTypes";
const WalletReducer = (
  state = {
    wallet: {},
  },
  action
) => {
  if (action.type == Actions.SET_WALLET_TRANSACTIONS_HISTORY) {
    return Object.assign({}, state, {
      wallet: action?.data,
    });
  } else {
    return state;
  }
};

export default WalletReducer;
